module.exports = __webpack_public_path__ + "media/img/download_app_store_white-aab014b3.png";